import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import PageHeader from 'components/ui/page_header';

export default function Header({ modelName, templateName, saving, saveDisabled, onCancel, onSave }) {
  return (
    <PageHeader containerWidth>
      <PageHeader.Heading description={templateName} title={`Edit ${modelName}`} />
      <PageHeader.Actions>
        <Button.Primary disabled={saving || saveDisabled} type="button" onClick={onSave}>
          Save
        </Button.Primary>
        <Button.Cancel disabled={saving} type="button" onClick={onCancel}>
          Cancel
        </Button.Cancel>
      </PageHeader.Actions>
    </PageHeader>
  );
}

Header.propTypes = {
  modelName: PropTypes.string.isRequired,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
  templateName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
